import { gql } from '@apollo/client';
import { bookmarksFragment } from '../fragments/bookmarks';

export const getAllBookmarks = gql`
  query BookmarksAll($limit: Limit!, $offset: Offset!) {
    bookmarks(limit: $limit, offset: $offset) {
      item {
        ...bookmarksItemFields
      }
    }
  }
  ${bookmarksFragment}
`;
